import { useState, useEffect } from 'react';
import '../styles/AchievementsModal.css';
import { ACHIEVEMENT_DEFS } from '../utils/achievements';

/**
 * Shows a stack of toast notifications for newly unlocked achievements.
 * Props:
 *   newIds – string[] of just-unlocked achievement IDs
 *   onDone – called after all toasts have faded
 */
function AchievementToast({ newIds, onDone }) {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (!newIds?.length) return;
    const t = setTimeout(() => {
      setVisible(false);
      onDone?.();
    }, 3200);
    return () => clearTimeout(t);
  }, [newIds, onDone]);

  if (!visible || !newIds?.length) return null;

  const defs = newIds.map(id => ACHIEVEMENT_DEFS.find(d => d.id === id)).filter(Boolean);

  return (
    <div className="achievement-toast-container">
      {defs.map((def) => (
        <div key={def.id} className="achievement-toast">
          <span className="achievement-toast-icon">{def.icon}</span>
          <div>
            <div className="achievement-toast-label">Achievement Unlocked!</div>
            <div className="achievement-toast-name">{def.title}</div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default AchievementToast;
